import type { FaireProductEntity } from "../../entity_types/product";

export const p_y592zckmke: FaireProductEntity = {
  token: "p_y592zckmke",
  type: "product",
  name: "Fall - Apple Cider Donuts Truffle Bar",
  brandToken: "b_adcrph7h",
  brandName: "Seattle Chocolate Presents Maeve",
  imageUrl:
    "https://cdn.faire.com/fastly/5429fed82f62ee0398240c945cae9cfb8102d8bdef55bf5d253edbcb4f302515.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7e2e0756baacb6e20efa4f73084d76d7d154341323b4882a27148e962871734.jpeg",
    "https://cdn.faire.com/fastly/06eb38ca2e6923901bcfee8ada66cdd32b1662b80416a502e54c9568a37cac70.jpeg",
    "https://cdn.faire.com/fastly/85bf4dfd4e7be048ec40caa07ac2ca0126e1f97ed8fc64839f7731fed165e744.jpeg",
  ],
  priceDollars: 3.66,
  description:
    "Inspired by the greatest reward for surviving a corn maze: the warm, sugar-dusted cider donut. This cozy milk chocolate truffle bar is spiced with cinnamon, packed with crunchy sugar bits, and studded with biscotti pieces for that fresh-from-the-farmstand feeling. It’s crisp mornings, hay in your hair, and a donut in each hand. No orchard visit required. (2.5oz)\n\nAbout the fall collection:\nFall is looking prettyyy friendsy this year. We’re pulling over at the roadside pumpkin patch with spiced chais, we’re dunking our apple cider donuts in chocolate at the orchard, and we’re definitely sitting around the bonfire with a mug of maple bourbon. So hey, wanna be friends?\n\n•\tWoman-owned and led\n•\t10% net profits donated to cocoa farmers \n•\tEthically sourced, non-GMO chocolate\n•\tCarbon neutral\n",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:36.859Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
